// Maps state slugs to state lottery commission logo URLs
// Most state lotteries don't have easily embeddable logos, so we use abbreviation badges as default

export const STATE_LOGOS: Record<string, string> = {
  // Add known state lottery logo URLs here as they become available
};

export function getStateLogoUrl(slug: string): string | null {
  return STATE_LOGOS[slug] || null;
}
